import { Hex } from 'js/bubbleCore/Hex';
import { IHexGridData } from 'js/bubbleCore/types';
import { IHexPixelSize } from 'js/bubbleCore/view/types';
import { isPointyTop } from 'js/bubbleCore/utils/isPointyTop';

const tempHexes = Hex.getTempHexes();

export function pxToHexPosition<T>(
  grid: IHexGridData<T>,
  x: number,
  y: number,
  {width, height, type, size}: IHexPixelSize,
  out?: PIXI.Point,
): PIXI.Point {
  const result = out || new PIXI.Point();

  let q: number;
  let r: number;

  const {x: offsetX, y: offsetY } = grid.offset;

  const properX = x - (width * 0.5) - (offsetX * width);
  const properY = y - (height * 0.5) - (offsetY * height);

  if (isPointyTop(type)) {
    q = (properX * Math.sqrt(3)/3 - properY / 3) / size;
    r = properY * 2/3 / size;
  } else {
    q = properX * 2/3 / size;
    r = (-properX / 3 + Math.sqrt(3)/3 * properY) / size;
  }

  const hex = tempHexes[grid.type].setAxial(q, r).round();
  result.set(hex.offsetPosition.x, hex.offsetPosition.y);

  return result;
}